import { render, staticRenderFns } from "./YogaPlacePhone.vue?vue&type=template&id=348b4b56&scoped=true&"
import script from "./YogaPlacePhone.vue?vue&type=script&lang=js&"
export * from "./YogaPlacePhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348b4b56",
  null
  
)

export default component.exports